import React, { useEffect } from "react";

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';

import servicioFormatos from '../../servicio/ServicioFormatos';
import servicioObjetos from "../../servicio/ServicioObjetos";

export const TablaMovimientosManuales2023 = (props) => {

    const {movimientosCapturados,movimientosSeleccionados,setMovimientosSeleccionados} = props;

    useEffect(() => {
    },[movimientosCapturados]);

    const plantillaError = (rowData, column) => {
         if (rowData.errores != null)
             return <Button icon="pi-md-remove-red-eye" tooltip="Ver error" onClick={() => verError(rowData)}></Button>
    }

    const verError = (objeto) => {
        if (objeto != null) {
            //this.setState({ listaErroresModal: objeto.errores, mostrarModalErrores: true });
        }
    }

    const formatofecha = (rowData, column) => {
        return servicioFormatos.formatearFechaStringArchivoIdse(rowData.fechaMovimiento);
    }

    const plantillaRegistroPatronal = (rowData, column) => {
        if(!servicioObjetos.esObjetoVacio(rowData.registroPatronal)){
            return rowData.registroPatronal;
        }
    }

    const agregarElementosSeleccionados = (event) => {
        setMovimientosSeleccionados(event.value);
    }

    return (<div className="card">
        <div className="p-grid">
            <div className="p-col-12">
                    <DataTable value={movimientosCapturados} header="Movimientos capturados" responsive={true}
                        resizableColumns={true} selection={movimientosSeleccionados} onSelectionChange={e => agregarElementosSeleccionados(e)} >
                        {/* <Column body={plantillaChecBox} header="Seleccionar" style={{ width: '150px' }} /> */}
                        <Column selectionMode="multiple" header="Seleccionados" style={{width:'10em'}}/>
                        <Column body={plantillaError} header="Error" style={{ width: '150px' }} />
                        <Column body={plantillaRegistroPatronal} header="RP" style={{ width: '250px' }} />
                        <Column field="tipoMovimiento" header="Movimiento" style={{ width: '150px' }} />
                        <Column body={formatofecha} header="Fecha" style={{ width: '150px' }} />
                        <Column field="tcTrabajador.numeroSeguridadSocial" header="NSS" style={{ width: '150px' }} />
                        <Column field="tcTrabajador.primerApellido" header="Apellido Paterno" style={{ width: '250px' }} />
                        <Column field="tcTrabajador.segundoApellido" header="Apellido Materno" style={{ width: '250px' }} />
                        <Column field="tcTrabajador.nombre" header="Nombre" style={{ width: '250px' }} />
                        <Column field="curp" header="Curp" style={{ width: '150px' }} />
                        <Column field="umf" header="UMF" style={{ width: '150px' }} />
                        <Column field="claveTrabajador" header="Cve. T." style={{ width: '150px' }} />
                        <Column field="tipoTrabajador" header="Tipo de Trabajador" style={{ width: '150px' }} />
                        <Column field="salarioDiarioIntegrado" header="SDI" style={{ width: '150px' }} />
                        <Column field="tipoSalario" header="Tipo de salario" style={{ width: '150px' }} />
                        <Column field="jornadaReducida" header="Jornada" style={{ width: '150px' }} />
                        <Column field="causaBaja" header="Baja" style={{ width: '150px' }} />
                    </DataTable>
                    {/* <Dialog visible={this.state.mostrarModalErrores} header="Notificación IMSS" modal={true} onHide={this.cerrarModalErrores}>
                        <center><h1>El envío al IMSS contiene los siguientes errores</h1></center>
                        <div className="p-grid">
                            <DataTable value={this.state.listaErroresModal} fixedHeader={true} responsive={true} scrollable style={{ width: '1100px' }}>
                                <Column field="0" header=""  style={{ width: '250px' }} />
                                <Column field="1" header=""  style={{ width: '250px' }} />
                                <Column field="2" header=""  style={{ width: '250px' }} />
                            </DataTable>
                        </div>
                    </Dialog> */}
                
            </div>
        </div>        
    </div>);
}